/* You must register this file at "website\src\i18n\fa-ir" */

export default {
    /* Global Vocabulary */


    /* Module special vocabulary */
    banks: {
        menu: {
            index: 'بانک‌ها',
            create: 'بانک جدید',
            list: 'بانک‌ها'
        },
        table_titles: {
            id: 'شناسه',
            name: 'نام',
            country: 'کشور',
            swift_bic: 'سوئیفت/بیک',
            show_on_home: 'نمایش در صفحه‌اصلی',
            setting: 'ویرایش / حذف',
        },
        edit: 'ویرایش بانک'
    },
    bank_accounts: {
        currency: 'ارز',
        payment_method: 'روش پرداخت',
        account_number: 'شماره حساب',
        edit_form: 'فرم ویرایش حساب بانکی',
    }
}

